var map = {
	"./board_and_batten_metal_siding.svg": 9279,
	"./board_and_batten_siding.svg": 25651,
	"./lap_siding.svg": 31285,
	"./stackstone_ash_siding.svg": 6248,
	"./stackstone_ash_siding_horizontal.svg": 92851,
	"./stackstone_ash_siding_vertical.svg": 52201,
	"./stackstone_shadow_siding.svg": 19618,
	"./stackstone_shadow_siding_horizontal.svg": 42481,
	"./stackstone_shadow_siding_vertical.svg": 63063,
	"./stackstone_smoke_siding.svg": 1293,
	"./stackstone_smoke_siding_horizontal.svg": 97728,
	"./stackstone_smoke_siding_vertical.svg": 16358,
	"./stone_siding.svg": 46821,
	"./stone_siding_horizontal.svg": 82984,
	"./stone_siding_vertical.svg": 82942,
	"./wood_grain-vertical-thumbnail.svg": 3636,
	"./wood_siding.svg": 63443,
	"./wood_siding_horizontal.svg": 79546,
	"./wood_siding_vertical.svg": 34104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53311;